import baseApi from './base.api'

export const aesCryptographyService = {
  ...baseApi,
  resource: 'aesCryptography',

  encrypt(plainText: string) {
    return baseApi.post(`${this.resource}/encrypt/plain-text`, plainText)
  }
}
